import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface ClientStatusEditorViewProps {
    label?: string;
    value: number | null;
    onChanged: (number: number | null) => void;
    mode: ControlMode;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class ClientStatusEditorView extends React.Component<ClientStatusEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        return (
            <DropdownView label={this.props.label === undefined ? 'Client status' : this.props.label}
                onGetErrorMessage={this.props.onGetErrorMessage}
                model={this.props.value}
                required={this.props.required}
                disabled={this.props.mode == 'display'}
                onChanged={(item) => { this.props.onChanged(item != null ? item.value : null); }}
                options={
                    [
                        { value: 0, label: 'Client' },
                        { value: 1, label: 'Will book' },
                        { value: 2, label: 'Interested' },
                        { value: 3, label: 'Only information request' },
                        { value: 4, label: 'Not interested' },
                        { value: 5, label: 'No more contact' },
                        { value: 6, label: 'Co-traveler' }
                    ]
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/clientstatus-editor.view.tsx